import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DEMO_MODE_BANNER_ASYNC = createAsyncTypes(
  'FETCH_DEMO_MODE_BANNER_ASYNC',
  'GlobalBanner'
)
